import { Dropdown, Spinner } from "react-bootstrap";

type Props = {
  isDownloading?: boolean;
  onDownload: () => void;
};

const ShortPDFItem = ({ isDownloading, onDownload }: Props) => (
  <Dropdown.Item
    onClick={onDownload}
    data-testid="report_summary_action_short_pdf"
    disabled={isDownloading}
  >
    <div className={"flex flex-gap-1 align-center"}>
      Export PDF (Short)
      {isDownloading && <Spinner size={"sm"} />}
    </div>
  </Dropdown.Item>
);

export default ShortPDFItem;
